import { useEffect } from 'react';

import { useStores } from '../../stores/useStores';

import {
  useBingoCurrentEvent,
  useBingoUpcomingEvents,
  useBingoHistoricalEvents,
  useBingoStorePackages,
  UPCOMING_EVENTS_DAYS_LIMIT,
  HISTORICAL_EVENTS_DAYS_LIMIT,
} from './useBingoQueries';

export const useBingoDataInitializer = () => {
  const { bingoStore } = useStores();

  const { isLoading: isLoadingCurrentEvent } = useBingoCurrentEvent();
  const { isLoading: isLoadingUpcomingEvents } = useBingoUpcomingEvents(UPCOMING_EVENTS_DAYS_LIMIT);
  const { isLoading: isLoadingHistoricalEvents } = useBingoHistoricalEvents(HISTORICAL_EVENTS_DAYS_LIMIT);
  const { isLoading: isLoadingStorePackages } = useBingoStorePackages();

  useEffect(() => {
    bingoStore.setShowLoadingCurrentEvent(isLoadingCurrentEvent);
    bingoStore.setShowLoadingUpcomingEvents(isLoadingUpcomingEvents);
    bingoStore.setFetchingHistoricalBingoEvents(isLoadingHistoricalEvents);
    bingoStore.setFetchingBingoStorePackages(isLoadingStorePackages);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingCurrentEvent, isLoadingUpcomingEvents, isLoadingHistoricalEvents, isLoadingStorePackages]);
};
